var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0506703 0.975553C0.140047 0.787198 0.333102 0.666687 0.545461 0.666687H11.4545C11.6669 0.666687 11.86 0.787198 11.9493 0.975553C12.0387 1.16391 12.0082 1.38586 11.871 1.54441L7.63636 6.44063V10.8C7.63636 10.9849 7.53848 11.1565 7.37767 11.2537C7.21686 11.3509 7.01606 11.3597 6.84697 11.277L4.66516 10.2104C4.48037 10.12 4.36364 9.93537 4.36364 9.73335V6.44063L0.128969 1.54441C-0.0081568 1.38586 -0.0387069 1.16391 0.0506703 0.975553ZM1.72108 1.73335L5.32558 5.90097C5.40886 5.99725 5.45455 6.11926 5.45455 6.24535V9.40374L6.54545 9.93707V6.24535C6.54545 6.11926 6.59114 5.99725 6.67442 5.90097L10.2789 1.73335H1.72108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a78305bf61bd8635366c72f88649a3c1.svg";
export { ForwardRef as ReactComponent };